import api from "./API";
export const setOrder = (params) => {
  return api.post(
    "https://www.propay.it.com/index.php/api/Urlorder/setOrder",
    params
  );
};
